import { ArgTypes } from '../utils/ArgValidation';
import { checkTypesAndCast } from '../utils/CheckTypesAndCast';
import { Maybe } from '../utils/typescript';

// com.tamr.recipe.models.flows.goldenRecords.Predicate

export const TYPE = 'Predicate';

// These fields are not actually optional from the perspective of the server,
//   but they are optional here to help the form UX for building filters
export interface Predicate {
  type: typeof TYPE
  expression: Maybe<string>
}
const argTypes = {
  type: ArgTypes.eq(TYPE as typeof TYPE),
  expression: ArgTypes.orUndefined(ArgTypes.string),
} as const;
export const fromJSON = checkTypesAndCast<Predicate, typeof argTypes>(argTypes);

export const argType = ArgTypes.object.withShape(argTypes);

export function isValid(filter: Predicate) {
  return !!filter.expression;
}
